var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-Carousel"},[_c('div',{class:[
      'swiper-container sw-Carousel_Container',
      (_vm.carouselKey + "-Carousel_Container")
    ]},[_c('div',{staticClass:"swiper-wrapper sw-Carousel_Wrapper"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide sw-Carousel_Slide"},[_vm._t("default",null,{"item":item})],2)}),0)]),_vm._v(" "),(!_vm.customPrevButtonClass && !_vm.customNextButtonClass)?_c('div',{staticClass:"sw-Carousel_Buttons",style:({
      top: ("" + (_vm.showPagination || _vm.showScrollbar
          ? ("calc(50% - " + (_vm.showPagination ? '30' : '8') + "px)")
          : '50%'))
    })},[_c('div',{class:[
        (_vm.carouselKey + "-Carousel_ButtonPrev"),
        'sw-Carousel_ButtonItem sw-Carousel_ButtonPrev'
      ]}),_vm._v(" "),_c('div',{class:[
        (_vm.carouselKey + "-Carousel_ButtonNext"),
        'sw-Carousel_ButtonItem sw-Carousel_ButtonNext'
      ]})]):_vm._e(),_vm._v(" "),(_vm.showPagination && !_vm.showScrollbar)?_c('div',{class:[
      'sw-Carousel_Pagination',
      (_vm.carouselKey + "-Carousel_Pagination")
    ]}):_vm._e(),_vm._v(" "),(_vm.showScrollbar && !_vm.showPagination)?_c('div',{class:[
      'sw-Carousel_Scrollbar',
      (_vm.carouselKey + "-Carousel_Scrollbar")
    ]}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }